const note = {
    version: '1.0.3',
    date: '2026-09-03',
    tags: ['Fix'],
    body: `
- **Conversion Error på et langt Outlook subject.** En Outlook sync med et langt subject kunne ikke konverteres til en timelog. Name forkortes nu automatisk, og hele teksten bliver stående i Description.
`,
};

export default note;
